<!-- src/views/PublicCourse.vue -->
<template>
  <div class="pc-root">
    <!-- 紅色條幅 -->
    <header class="pc-hero">
      <h1>=限時免費課程=</h1>
      <p>您的《Web3項目開發的學習路線藍圖》將會在30–60分鐘內發送到您的電郵信箱…</p>
    </header>

    <!-- 主內容容器 -->
    <main class="pc-container">
      <!-- 影片 -->
      <section class="pc-video">
        <div class="pc-video__note">注意：由於院長我服務人數有限，名額滿額後將會關閉影片</div>
        <div class="aspect-video">
          <iframe
            class="w-full h-full"
            :src="embedUrl"
            title="公開課影片"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          />
        </div>
      </section>

      <!-- 說明 + 第一顆綠色按鈕 -->
      <section class="pc-section pc-center">
        <h2 class="pc-h2">《0基礎 Web3項目開發 的學習路線》</h2>
        <p class="pc-lead">
          你只需要掌握方法和模版，了解一個中大型Dapp項目是如何從無到有製作開發出來的，
          你也可以做出自己的 Web3 項目！在這個浪潮賺取您的第一桶金！！
        </p>
        <router-link to="/purchase" class="pc-btn pc-btn--green">》 進入課程目錄＆簡介 《</router-link>
      </section>

      <!-- 大標／副標 & 展示圖 -->
      <section class="pc-section pc-center">
        <h3 class="pc-h3">只要您願意堅持，肯定能掌握</h3>
        <p class="pc-sub">學習最好的時間，就是現在，因為未來的你肯定比今天更沒時間！</p>
        <div class="pc-showcase">
          <img
            class="pc-showcase__img"
            src="/images/giftpack.png"
            alt="課程贈品與學習路線示意圖"
            loading="lazy"
            decoding="async"
          />
          <!-- 若想改回占位，改用：
          <div class="pc-showcase__ph"></div>
          -->
        </div>
      </section>

      <!-- 痛點清單 -->
      <section class="pc-section pc-center">
        <ul class="pc-list">
          <li>❌ 想要學智能合約，卻不知道如何下手？</li>
          <li>❌ 自己連代碼都沒接觸過，覺得太難，不敢想像？</li>
          <li>❌ 35歲中年危機，想換個行業發展？</li>
          <li>❌ 知道項目賺錢！但是完全不知道項目方如何從0變1，一頭霧水？</li>
          <li>❌ 有項目的公開代碼，但缺不會部署？</li>
        </ul>
      </section>

      <!-- 黑卡 + 綠鈕 -->
      <section class="pc-cta-card">
        <div class="pc-cta-title">立即報名</div>
        <div class="pc-cta-note">由於院長我服務人數有限，如果滿員將會關閉報名通道，敬請諒解</div>
        <router-link to="/purchase" class="pc-btn pc-btn--green pc-btn--lg">》 進入課程目錄＆簡介 《</router-link>
      </section>

      <!-- Q&A -->
      <section class="pc-section pc-qa">
        <h3 class="pc-qa-q">沒有編寫程式基礎，可以學嗎？</h3>
        <p class="pc-qa-a">
          可以的，智能合約 Solidity 語言本來語法就比較獨立易懂，所以問題不大。但如果有一點點
          JS / HTML 基礎更好，因為你也需要自己能做出簡單的前端頁面，但不影響鏈端的學習。
          我們免費的《Web3項目開發 的學習路線》資料中也整理了前端速成資源，花2–3小時過一遍會更輕鬆。
        </p>

        <h3 class="pc-qa-q">學完後能直接去上班嗎？</h3>
        <p class="pc-qa-a">
          可以的，課程初衷是做出自己的 Dapp 創業項目，你能獨立做出項目，這個能力正是老闆想要的。
          並且課程有一個中大型實戰案例，跟著流程部署即可作為面試作品。
        </p>

        <h3 class="pc-qa-q">我可以免費退款嗎？</h3>
        <p class="pc-qa-a">
          如果透過支付寶／微信支付，24小時內，播放課程內容不超過 20% 的情況可以 100% 退款。
          （信用卡支付受平台限制，暫時無法退款，敬請諒解）
        </p>

        <h3 class="pc-qa-q">學習上有問題可以聯繫院長解決？</h3>
        <p class="pc-qa-a">
          可以的，學習過程中有任何問題，可以直接私信我；院長本人親自為你解答，1對1服務。
          一般工作日早上9點–下午4點比較活躍；晚上看到訊息也會回覆。
        </p>

        <!-- 置中綠鈕 -->
        <div class="pc-center">
          <router-link to="/purchase" class="pc-btn pc-btn--green pc-btn--xl pc-bottom-btn">
            》 進入課程目錄＆簡介 《
          </router-link>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
import { computed } from 'vue'
const youtube = 'https://youtu.be/nJtinqWl6h4'
const embedUrl = computed(() => {
  const id = youtube.split('/').pop()?.split('?')[0] || ''
  return `https://www.youtube.com/embed/${id}`
})
</script>

<style scoped>
/* 隱藏全站 Header / Footer（避免分心） */

.pc-root {
  background: #fff;
  color: #111;
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans",
    "Helvetica Neue", Arial, "Apple Color Emoji", "Segoe UI Emoji";
}

/* ===== 紅色條幅 ===== */
.pc-hero {
  background: #9b2f2f;
  color: #fff;
  text-align: center;
  padding: clamp(36px, 8vw, 72px) 16px;
}
.pc-hero h1 {
  margin: 0 0 10px 0;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  letter-spacing: .02em;
}
.pc-hero p {
  margin: 0 auto;
  max-width: 980px;
  font-size: clamp(16px, 2.2vw, 22px);
  opacity: .95;
}

/* ===== 容器 ===== */
.pc-container {
  max-width: 980px;
  margin: 36px auto 120px;
  padding: 0 16px;
}

/* ===== 影片區 ===== */
.pc-video { margin-top: 8px; }
.pc-video__note {
  text-align: center;
  font-size: 12px;
  color: #7a5b00;
  background: #fff8db;
  border: 1px solid #f2e3a6;
  padding: 6px 10px;
  border-radius: 8px 8px 0 0;
  width: fit-content;
  margin: 0 auto;
}
.aspect-video {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background: #000;
  border: 1px solid rgba(0,0,0,.06);
  overflow: hidden;
}
.aspect-video iframe {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
}

/* ===== 共用區塊 ===== */
.pc-section { margin-top: 48px; }
.pc-center { text-align: center; }

.pc-h2 {
  margin: 0 0 10px 0;
  font-size: clamp(22px, 3.2vw, 32px);
  font-weight: 800;
}
.pc-lead {
  margin: 0 auto 18px;
  max-width: 820px;
  color: #444;
  line-height: 1.75;
  font-size: clamp(15px, 2vw, 18px);
}

/* 展示區（圖片與占位二擇一） */
.pc-showcase { margin-top: 16px; }
.pc-showcase__img{
  display: block;
  width: 100%;
  max-height: clamp(220px, 45vw, 520px);
  object-fit: contain;          /* 圖片完整呈現 */
  border-radius: 12px;
  box-shadow: 0 6px 28px rgba(0,0,0,.12);
  background: #fff;             /* 透明 PNG 也能好看 */
}
.pc-showcase__ph {
  height: clamp(220px, 40vw, 420px);
  background: #f3f3f3;
  border: 1px dashed #ddd;
  border-radius: 12px;
}

/* 痛點清單 */
.pc-list {
  display: grid;
  gap: 10px;
  justify-items: center;
  padding: 0;
  margin: 0;
  list-style: none;
  font-size: clamp(18px, 2.6vw, 24px);
  font-weight: 700;
}

/* 黑色 CTA 卡片 */
.pc-cta-card {
  margin-top: 36px;
  background: #111;
  color: #fff;
  border-radius: 12px;
  padding: 26px 18px 30px;
  text-align: center;
}
.pc-cta-title {
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 800;
  margin-bottom: 8px;
}
.pc-cta-note {
  color: rgb(255, 217, 0);
  font-size: 14px;
  margin-bottom: 14px;
}

/* Q&A */
.pc-qa { margin-top: 42px; }
.pc-qa-q {
  font-size: clamp(28px, 3.6vw, 44px);
  font-weight: 800;
  margin: 26px 0 10px;
}
.pc-qa-a {
  font-size: clamp(15px, 2vw, 18px);
  line-height: 1.9;
  color: #333;
}

/* 按鈕 */
.pc-btn {
  display: inline-block;
  border-radius: 12px;
  padding: 12px 18px;
  font-weight: 800;
  letter-spacing: .02em;
  text-decoration: none;
  transition: transform .15s ease, box-shadow .2s ease, background .2s ease;
  border: 1px solid transparent;
}
.pc-btn--green {
  background: #2ea44f;
  color: #fff;
  box-shadow: 0 6px 16px rgba(46,164,79,.25);
}
.pc-btn--green:hover { background: #279546; transform: translateY(-1px); }
.pc-btn--lg { padding: 14px 28px; font-size: clamp(16px, 2.4vw, 20px); }
.pc-btn--xl { padding: 18px 36px; font-size: clamp(18px, 3vw, 26px); }
.pc-bottom-btn { margin-top: 24px; }

/* 響應 */
@media (max-width: 640px) {
  .pc-container { margin-bottom: 80px; }
}
</style>
